import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" className="py-0 text-align-left div-p-0 left-content accessibility-text-blade text-blade-header heading-accessibility" mdxType="TextBlock" />
    <h2 {...{
      "id": "interested-in-joining-the-beta-program-for-adobe-pdf-accessibility-checker-api"
    }}>{`Interested in joining the Beta Program for Adobe PDF Accessibility Checker API?`}</h2>
    <p>{`The PDF Accessibility Checker API checks the accessibility of documents at scale by running a series of tests on PDF documents. It leverages the same technology as the Accessibility Checker found in Acrobat Pro.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Primary capabilities of the API include:`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Generates an accessibility report that checks 32 items across four categories and reports them as ‘passed’, ‘failed’, or ‘needs manual check’. These categories include document content (reading order, title, color contrast, etc.), page content (tags, navigation links, and more), forms, tables, and lists, and alternate text and headings.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Option to embed the HTML report within the PDF or export it separately as a JSON file.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Option to specify the pages in the document to be checked.`}</p>
      </li>
    </ul>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Use this form to have an Adobe representative contact you with more information about the Beta program or to answer other questions you have about the API. For additional information, please refer to the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/document-services/docs/apis/#tag/PDF-Accessibility-Checker"
      }}>{`documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      